module.exports = __webpack_public_path__ + "img/spritemap.f4fc956.svg";